import {
  PropsWithTheme,
  OwnUpGridWrapper,
  OwnUpHeadlineBook,
  ALOE_100,
  MOSS_100
} from '@rategravity/own-up-component-library';
import styled from 'styled-components';

export const CTAButton3Wrapper = styled(OwnUpGridWrapper)`
  background-color: ${MOSS_100};
  border-radius: 8px;
  padding-bottom: 24px;
  text-align: center;
  margin: 40px auto;
  position: sticky;
  top: 80px;
`;

export const CTAButton3OwnUpLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  background-color: ${ALOE_100};
  border-radius: 8px;
  padding: 8px 0px;
`;

export const CTAButton3HeadlineWrapper = styled.div`
  padding: 64px 32px;
`;

export const CTAButton3HeadlineText = styled(OwnUpHeadlineBook)`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${ALOE_100};
`;

export const CTAButton3LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0px 16px;
`;

export const CTAButton3Link = styled.a`
  color: ${({ theme }: PropsWithTheme<{}>) => theme.underlineLinkColors.linkFontColor};
  text-decoration: none;
  width: 100%;
`;
